import { Box, Heading, Text, VStack, type BoxProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { PROFILE_SCROLL_COLUMN_MIN_H } from '@/constants/mobileLayout';
import { Card } from '@/views/ProfilePage/Card';

export function ScoresListCard(
  props: BoxProps & {
    title: string;
    emptyMessage: string;
    isEmpty: boolean;
    children: ReactNode;
    /** When false (mobile stack), page scrolls; when true (lg+ columns), list scrolls inside card. */
    scrollContained?: boolean;
  },
) {
  const { title, emptyMessage, isEmpty, children, scrollContained = true, ...cardProps } = props;

  const listBody = isEmpty ? (
    <Text fontSize='sm' color='gray.500'>
      {emptyMessage}
    </Text>
  ) : (
    children
  );

  if (!scrollContained) {
    return (
      <Card w='full' display='flex' flexDirection='column' {...cardProps}>
        <VStack spacing={4} align='stretch'>
          <Heading fontSize='lg'>{title}</Heading>
          {listBody}
        </VStack>
      </Card>
    );
  }

  return (
    <Card
      w='full'
      borderRadius={0}
      display='flex'
      flexDirection='column'
      minH={PROFILE_SCROLL_COLUMN_MIN_H}
      {...cardProps}
    >
      <Box flex={1} minH={0} display='flex' flexDirection='column' overflow='hidden'>
        <VStack flex={1} minH={0} spacing={4} align='stretch'>
          <Heading fontSize='lg' flexShrink={0}>
            {title}
          </Heading>
          <Box
            flex={1}
            minH={0}
            overflowY='auto'
            overflowX='hidden'
            data-stage-panel-scroll
            sx={{ WebkitOverflowScrolling: 'touch' }}
          >
            {listBody}
          </Box>
        </VStack>
      </Box>
    </Card>
  );
}
